module.exports = __webpack_public_path__ + "img/欧洲.157edf52.jpg";